// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"7712b4ec","816":"edb8196d"}[chunkId] + ".chunk.css";
};